export default __webpack_public_path__ + "static/media/homer-so-good.301d4fec.gif";